// Voice — inbound agent (Twilio-backed telephony) field group for the
// interface editor drawer (agent.md interfaceFields split). Provider detail
// (Twilio) appears only here and in stored config, never as the interface
// label (§2.13).
import type { components } from "../../../api/schema";
import { Select, Stack, TextInput } from "../../../ui";
import type { InterfaceFieldsProps } from "../lib/connectionDraft";

type ConnectionInitiator = components["schemas"]["ConnectionInitiator"];

export function TelephonyInterfaceFields({
  draft,
  onDraftChange,
}: InterfaceFieldsProps) {
  return (
    <Stack gap={4}>
      <Select
        label="Conversation starter"
        required
        value={draft.initiator}
        onChange={(event) => {
          onDraftChange({
            ...draft,
            initiator: event.currentTarget.value as ConnectionInitiator,
          });
        }}
      >
        <option value="marker">Inbound agent</option>
      </Select>
      <TextInput
        label="From number"
        required
        value={draft.fromNumber}
        onChange={(event) => {
          onDraftChange({ ...draft, fromNumber: event.currentTarget.value });
        }}
      />
      <TextInput
        label="To number"
        required
        value={draft.toNumber}
        onChange={(event) => {
          onDraftChange({ ...draft, toNumber: event.currentTarget.value });
        }}
      />
      <TextInput
        label="Account SID"
        required
        value={draft.accountSid}
        onChange={(event) => {
          onDraftChange({ ...draft, accountSid: event.currentTarget.value });
        }}
      />
      <TextInput
        label="Auth-token secret reference"
        required
        value={draft.authTokenSecretRef}
        onChange={(event) => {
          onDraftChange({
            ...draft,
            authTokenSecretRef: event.currentTarget.value,
          });
        }}
      />
    </Stack>
  );
}
